import { customMedia } from '@space-core/styles'
import styled from 'styled-components'

export const ContainerImage = styled.div`
  width: 6.25rem;
  height: 3.5rem;

  ${customMedia.greaterThan('md')`
    width: 12rem;
    height: 6.75rem;
  `}
`
